// MAIN SITE
const config = {
  baseURL: 'https://regulationcity.com/wp-json/api',

  // use this to run local
  // authBaseURL: 'https://stagingregcityapi.azurewebsites.net/api',

  // use this for deployed solution
  authBaseURL: 'https://webapi.regulationcity.com/api',

  HomeURL: '/app',
  AppURL: 'https://regulationcity.com/app',
  WordPressURL: 'https://regulationcity.com/',
  ImagesFolder:
    'https://adminwordflow.sharepoint.com/sites/RegulationCity/PublishingImages/',
};

export default config;

// STAGING SITE
// const config = {
//   baseURL: "https://www.staging.regulationcity.com/wp-json/api",
//   authBaseURL: 'https://stagingregcityapi.azurewebsites.net/api',
//   HomeURL: "/app",
//   AppURL: "https://www.staging.regulationcity.com/app/",
//   WordPressURL: "https://www.staging.regulationcity.com/",
//   ImagesFolder: 'https://adminwordflow.sharepoint.com/sites/RegulationCity/PublishingImages/'
// };

// export default config;
